import { addMonths, startOfMonth, subYears } from 'date-fns';

export const allTimestampsOneYear = () => {
  const timestamps = [];
  const now = new Date();
  const oneYearAgo = startOfMonth(addMonths(subYears(now, 1), 1));
  let currentDate = oneYearAgo;
  while (currentDate < now) {
    timestamps.push(currentDate.getTime());
    currentDate = addMonths(currentDate, 1);
  }
  return timestamps;
};
